import React from "react";
import { nameTipsTs } from "../../../types/types";
type LgSealMarkStatus = "inProgress" | "passed" | "notPass" | "expired" | "warning"

export const nameTips = (ele: any): nameTipsTs => {
    let temp = {
        color: '#ff0000',
        text: '未开始'
    }
    switch (ele.planStatus) {
        case 0:
            temp = {
                color: '#ff0000',
                text: '未开始'
            }
            break;
        case 1:
            temp = {
                color: '#0099ff',
                text: '报名中'
            }
            break;
        case 2:
            temp = {
                color: '#ff7200',
                text: '报名审核中'
            }
            break;
        case 21:
            temp = {
                color: '#ff7200',
                text: '报名资格审核中'
            }
            break;
        case 22:
            temp = {
                color: '#ff7200',
                text: '考生资格审核中'
            }
            break;
        case 3:
        case 4:
        case 5:
            // temp = ele?.admissionInfo ? {
            //     color: '#009900',
            //     text: '录取中'
            // } : {
            //     color: '#ff7200',
            //     text: '报名审核中'
            // }
            temp = {
                color: '#009900',
                text: '录取中'
            }
            break;
        case 6:
            temp = {
                color: '#999999',
                text: '已结束'
            }
            break;
        case 6:
            temp = {
                color: '#ff0000',
                text: '补录中'
            }
            break;
        default:
            temp = {
                color: '#999999',
                text: '已结束'
            }
            break;
    }

    return temp
}
export const OptionFunContext = React.createContext({
    checkPlan: (item) => { },
    enroll: (item: any, type?: string) => { },
    changeEnroll: (value: boolean)=>{},
    setSelectItem: (item: any) => { },
    list: [],
});
export const getSealMarkInfo = (ele) => {
    let status: LgSealMarkStatus = "passed";
    let text = "已报名";
    let color = "#009900";
    const auditInfo = ele?.auditInfo;
    const admissionInfo = ele?.admissionInfo;

    // 判断审核状态
    const getAuditRecords = () => {
        if (auditInfo?.audit?.auditStatus == 0 || auditInfo?.audit?.auditStatus == 3) {
            status = "inProgress";
            text = "审核中";
            color = "#0099ff";
        } else if (auditInfo?.audit?.auditStatus == 1) {
            status = "passed";
            text = "审核通过";
            color = "#009900";
        } else if (auditInfo?.audit?.auditStatus == 2) {
            status = "notPass";
            text = "审核未通过";
            color = "#ff0000";
        }
    }
    // 判断录取状态
    const getAdmissionInfo = () => {
        text = "已录取";
        if (admissionInfo) {
            if (admissionInfo?.admissionStatus == 0) {
                status = "warning";
                text = "待录取";
                color = "#ff6600";
            } else if (admissionInfo?.admissionStatus == 1) {
                status = "passed";
                text = "已录取";
                color = "#009900";
            } else if (admissionInfo?.admissionStatus == 2) {
                status = "passed";
                text = "候补";
                color = "#009900";
            } else if (admissionInfo?.admissionStatus == 3) {
                status = "notPass"
                text = "未录取";
                color = "#ff0000";
            } else if (admissionInfo?.admissionStatus == 4) {
                status = "inProgress"
                text = "拟录取";
                color = "#0066ff";
            }
        } else {
            getAuditRecords();
        }
    }
    switch (ele?.planStatus) {
        case 0:
            status = "warning";
            text = "未报名";
            color = "#ff0000";
            break;
        case 1:
            if (auditInfo && !admissionInfo) {
                getAuditRecords();
            } else if (admissionInfo) {
                getAdmissionInfo();
            } else {
                status = "passed";
                text = "已报名";
                color = "#009900";
            }
            break;
        case 2:
            // getAuditRecords();
            if (auditInfo && !admissionInfo) {
                getAuditRecords();
            } else if (admissionInfo) {
                getAdmissionInfo();
            }
            break;
        case 3:
            getAdmissionInfo();
            break;
        default:
            getAdmissionInfo();
            break;
    }

    return {
        status,
        text,
        color,
        imgSrc: getImgName(text)
    }
}
export const getImgName = (text) => {
    let temp = 'awaitReview'
    switch (text) {
        case '已报名':
            temp = 'enrolled'
            break;
        case '审核中':
            temp = 'awaitReview'
            break;
        case '审核通过':
            temp = 'reviewAdopt'
            break;
        case '审核未通过':
            // temp = 'reviewNot'
            temp = 'reviewNot (1)'
            break;
        case '待录取':
            temp = 'awaitAdmit'
            break;
        case '已录取':
            temp = 'admited'
            break;
        case '未录取':
            temp = 'notAdmit'
            break;
        case '候补':
            temp = 'alternate'
            break;
        case '未报名':
            temp = 'reviewNot'
            break;
        case '已完成':
            temp = 'completed'
            break;
        default:
            temp = 'awaitReview'
            break;
    }
    return temp + '.png'
}

export const defaultBasicOrdere = [
    'name',
    'gender',
    'idCard',
    'avatarItem',
    'phoneItem',
    'emailItem',
    'enrollMajorItem',
    'firstVolunteerItem',
    'secondVolunteerItem',
    'thirdVolunteerItem',
    'allowAdjustItem',
    'sourceItem',
    'talentedStudentItem',
    'languageScoreItem',
    'mathScoreItem',
    'englishScoreItem',
    'physicsScoreItem',
    'chemistryScoreItem',
    'biologyScoreItem',
    'politicScoreItem',
    'historyScoreItem',
    'geographyScoreItem',
    'sportScoreItem',
]

// 根据 fieldOrder 生成顺序数组的函数
export function generateOrderedArray(basicField) {
    // 获取 isedit.basicField 对象的所有键（字段名）
    const keys = Object.keys(basicField);

    // 过滤出具有 fieldOrder 属性的键和不具有 fieldOrder 属性的键
    const orderedKeys = keys.filter(key => basicField[key]?.fieldOrder !== undefined && basicField[key].fieldOrder !== -1);
    const unorderedKeys = keys.filter(key => basicField[key]?.fieldOrder === undefined || basicField[key].fieldOrder === -1);

    // 根据字段的 fieldOrder 属性值进行排序
    orderedKeys.sort((key1, key2) => basicField[key1].fieldOrder - basicField[key2].fieldOrder);

    // return orderedKeys
    // 将有序键和无序键合并返回
    return [...orderedKeys, ...unorderedKeys];
}
